export default () => ({
  playing: false,
  loaded: false,
  visible: false,
  observer: null,
  motion: null,
  onMotionChange: null,
  onVisibilityChange: null,

  init() {
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.onMotionChange = () => this.updatePlayback();
    this.onVisibilityChange = () => this.updatePlayback();
    this.motion.addEventListener('change', this.onMotionChange);
    document.addEventListener('visibilitychange', this.onVisibilityChange);

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.updatePlayback();
      }, { threshold: 0.01 });
      this.observer.observe(this.$el);
    } else {
      this.visible = true;
      this.updatePlayback();
    }
  },

  updatePlayback() {
    const video = this.$refs.video;
    if (!video) return;

    if (this.motion.matches || !this.visible || document.hidden) {
      video.pause();
      this.playing = false;
      return;
    }

    if (!this.loaded) {
      video.querySelectorAll('source[data-src]').forEach(source => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.muted = true;
      video.load();
      this.loaded = true;
    }

    const attempt = video.play();
    if (attempt) attempt.catch(() => { this.playing = false; });
  },

  destroy() {
    if (this.observer) this.observer.disconnect();
    if (this.motion) this.motion.removeEventListener('change', this.onMotionChange);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    if (this.$refs.video) this.$refs.video.pause();
  },
});
